import React, { useEffect, useRef } from 'react'
// @ts-ignore
import * as THREE from 'three'

function ThreeScene() {
    const containerRef = useRef(null);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const loader = new THREE.TextureLoader();
            const cross = loader.load("./white.jpg");

            const scene = new THREE.Scene();

            // Objects
            const geometry = new THREE.TorusGeometry(0.7, 0.2, 16, 100);
            const particlesGeometry = new THREE.BufferGeometry();
            const particlesCnt = 5000;

            const posArray = new Float32Array(particlesCnt * 3);
            // xyz, xyz, xyz, xyz

            for (let i = 0; i < particlesCnt * 3; i++) {
                //   posArray[i] = Math.random();
                //   posArray[i] = Math.random() - 0.5;
                posArray[i] = (Math.random() - 0.5) * (Math.random() * 5);
            }

            particlesGeometry.setAttribute(
                "position",
                new THREE.BufferAttribute(posArray, 3)
            );

            // Materials
            const material = new THREE.PointsMaterial({
                size: 0.005,
            });
            const particlesMaterial = new THREE.PointsMaterial({
                size: 0.005,
                transparent: true,
                map: cross,
                blending: THREE.AdditiveBlending,
            });

            // Mesh
            const sphere = new THREE.Points(geometry, material);
            const particlesMesh = new THREE.Points(
                particlesGeometry,
                particlesMaterial
            );

            scene.add(sphere, particlesMesh);

            // Lights

            const pointLight = new THREE.PointLight(0xffffff, 0.1);
            pointLight.position.x = 2;
            pointLight.position.y = 3;
            pointLight.position.z = 4;
            scene.add(pointLight);

            /**
             * Sizes
             */
            const sizes = {
                width: window.innerWidth,
                height: window.innerHeight,
            };

            const handleResize = () => {
                // Update sizes
                sizes.width = window.innerWidth;
                sizes.height = window.innerHeight;

                // Update camera
                camera.aspect = sizes.width / sizes.height;
                camera.updateProjectionMatrix();

                // Update renderer
                renderer.setSize(sizes.width, sizes.height);
                renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            };

            window.addEventListener("resize", handleResize);

            /**
             * Camera
             */
            // Base camera
            const camera = new THREE.PerspectiveCamera(
                75,
                sizes.width / sizes.height,
                0.1,
                100
            );
            camera.position.x = 0;
            camera.position.y = 0;
            camera.position.z = 2;
            scene.add(camera);

            /**
             * Renderer
             */
            const renderer = new THREE.WebGLRenderer();
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            renderer.setClearColor(new THREE.Color("#21282a"), 1);
            // @ts-ignore
            containerRef.current?.appendChild(renderer.domElement);


            /**
             * Animate
             */

            const clock = new THREE.Clock();

            const tick = () => {
                const elapsedTime = clock.getElapsedTime();

                sphere.rotation.y = 0.5 * elapsedTime;
                particlesMesh.rotation.y = -0.1 * elapsedTime;

                // Render
                renderer.render(scene, camera);

                // Call tick again on the next frame
                window.requestAnimationFrame(tick);
            };

            tick();

            // Clean up the event listener when the component is unmounted
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);

    return (
        <div className={`fixed top-0 left-0 outline-none w-full h-[100vh]`} ref={containerRef} />
    )
}

export default ThreeScene